import { useTheme } from "next-themes";

interface AIAssistantHeaderProps {
  isLoading: boolean;
}

export function AIAssistantHeader({ isLoading }: AIAssistantHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-4">
      {isLoading && (
        <span className="inline-block animate-pulse text-muted-foreground text-sm font-normal">
          Tenker...
        </span>
      )}
    </div>
  );
}